/**
 * @file Exemplo
 * jsdoc Board.js ControlLevel.js  Construtor.js ControlGame.js -d ../../documention
 * @author William Luis Alves Ferreira (git:illiamw)
 * @version 2.0.0
 */

import React from "react";


/**
 * @param {Null} Null Null
 * @description Classe geradora da função app
 * @constructor
 */

export default function View1A(props) {
  // ROTEAMENTO - colocar controle de estados da aplicação
  return (
    <div className="d-flex container min-vh-100 align-items-center"> 
      <div className="d-flex flex-column align-items-center w-100 view1 
                  bg-color5 text-white1 text-center arround-12">
        <div className="w-100 h-100 p-1 p-sm-5">
          {props.conteudo}
        </div>
      </div>
    </div>
  );
}